import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bark)',
      color: 'rgba(255,255,255,.65)',
      padding: '3rem 2rem'
    }}>
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '2rem'
      }}>
        <div>
          <div style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: '1.1rem',
            color: '#fff',
            marginBottom: '0.3rem'
          }}>
            Fornbo Samfällighetsförening
          </div>
          <div style={{
            fontSize: '0.75rem',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            opacity: 0.5
          }}>
            Fornbo · Malmköping
          </div>
        </div>
        <ul style={{
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.4rem'
        }}>
          <li><Link to="/#aktuellt" style={footerLinkStyle}>Aktuellt</Link></li>
          <li><Link to="/#ansvarsomraden" style={footerLinkStyle}>Ansvarsområden</Link></li>
          <li><Link to="/#foreningen" style={footerLinkStyle}>Föreningen</Link></li>
          <li><Link to="/#sjon" style={footerLinkStyle}>Sjön Nedingen</Link></li>
        </ul>
        <ul style={{
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.4rem'
        }}>
          <li><Link to="/#dokument" style={footerLinkStyle}>Dokument</Link></li>
          <li><Link to="/#kontakt" style={footerLinkStyle}>Kontakt</Link></li>
          <li><Link to="/styrelsen" style={footerLinkStyle}>Styrelsen (skyddad)</Link></li>
        </ul>
      </div>
      <div style={{
        textAlign: 'center',
        fontSize: '0.72rem',
        color: 'rgba(255,255,255,.3)',
        paddingTop: '2rem',
        marginTop: '2rem',
        borderTop: '1px solid rgba(255,255,255,.1)',
        maxWidth: '1100px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}>
        © {new Date().getFullYear()} Fornbo Samfällighetsförening - By{' '}
        <a
          href="mailto:olof.wallentinsson@gmail.com"
          style={{
            color: 'rgba(255,255,255,.5)',
            textDecoration: 'underline',
            transition: 'color 0.18s'
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,.8)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,.5)'}
        >
          M.I.T.H. Digital Engineering AB
        </a>
      </div>
    </footer>
  );
}

const footerLinkStyle = {
  color: 'rgba(255,255,255,.6)',
  textDecoration: 'none',
  fontSize: '0.82rem',
  transition: 'color 0.18s'
};
